var fields = {
    gaps: {
        type: 'group',
        members: ['gaps', 'card_gaps', 'card_margin'],
        field: {
            type: 'size',
            limits: [0, 10]
        }
    },

    card_width: {
        type: 'percent',
        limits: [30, 100]
    },

    photo_shape: {
        type: 'radio',
        values: ['square', 'round']
    },
    photo_size: {
        type: 'radio',
        values: ['a-medium', 'a-thumbnail', 'a-small', 'custom']
    },
    photo_width: {
        type: 'size',
        limits: [50, 100]
    },

    // Colors
    card_colors: {
        type: 'group',
        members: [
            //'base_color',
            'card_base_color',
            'card_border_color',
            'card_divider_color',
            'card_shadow_color',
            'card_even_row_color'
        ],
        field: {
            group: 'card',
            type: 'color'
        }
    },

    text_colors: {
        type: 'group',
        members: [
            'name_color',
            'position_color',
            'short_text_color',
            'contacts_color',
            'social_color'
        ],
        field: {
            group: 'text',
            type: 'color'
        }
    },

    text_transforms: {
        type: 'group',
        members: ['name_text_transform', 'position_text_transform', 'short_text_text_transform'],
        field: {
            type: 'radio',
            values: ['none', 'uppercase']
        }
    },

    font_sizes: {
        type: 'group',
        members: ['name_font_size', 'position_font_size', 'short_text_font_size'],
        field: {
            type: 'size',
            limits: [12, 20]
        }
    },

    bolds: {
        type: 'group',
        members: ['name_bold', 'position_bold', 'short_text_bold'],
        field: {
            type: 'boolean'
        }
    },

    italics: {
        type: 'group',
        members: ['name_italic', 'position_italic', 'short_text_italic'],
        field: {
            type: 'boolean'
        }
    },

    // Blocks margins
    top_margins: {
        type: 'group',
        members: [
            'photo_top_margin',
            'name_top_margin',
            'position_top_margin',
            'divider_top_margin',
            'short_text_top_margin',
            'contacts_top_margin',
            'social_top_margin'
        ],
        field: {
            type: 'size',
            limits: [0, 15]
        }
    }
};

var rules = {
    grid: {
        exclude: []
    },
    table: {
        exclude: [
            'name_color',
            'position_color',
            'short_text_color',
            'social_color'
        ]
    },
    widget: {
        exclude: [
            'photo_size'
        ]
    },
};

var AwesomeRandom = function () {
    var self = this;
    self.number = function (limit) {
        if(limit.length > 2){
            return;
        }
        var min = limit[0];
        var max = limit[1];
        return Math.floor(Math.random() * (max - min + 1) + min);
    };

    self.boolean = function () {
        return this.number([0,1]);
    };

    self.size = function (limit) {
        return this.number(limit) + 'px';
    };

    self.percent = function (limit) {
        return this.number(limit) + '%';
    };

    self.radio = function (values) {
        if(values.length < 1){
            return;
        }
        return values[Math.floor(Math.random() * values.length)];
    };

    self.array = function (array) {
        return _.shuffle(array);
    };

    self.color_delta = function (number, range) {
        var min = parseInt(number) - range < 0 ? 0 : parseInt(number) - range;
        var max = parseInt(number) + range > 255 ? 255 : parseInt(number) + range;
        return [min, max];
    };

    self.invert_color = function (color) {
        var r = 0xFF ^ color[0];
        var g = 0xFF ^ color[1];
        var b = 0xFF ^ color[2];
        return [r,g,b];
    };
    
    self.black_or_white = function (color) {
        var lightness = color[0]*0.2126 + color[1]*0.7152 + color[2]*0.0722;
        return lightness >= 127 ? [0, 0, 0] : [255, 255, 255];
    };

    self.color = function (seed_color) {
        var limits = [];
        if(seed_color === null){
            limits[0] = [0, 255];
            limits[1] = [0, 255];
            limits[2] = [0, 255];
        }else{
            //30, 250, 56
            limits[0] = self.color_delta(seed_color[0], 10);
            limits[1] = self.color_delta(seed_color[1], 10);
            limits[2] = self.color_delta(seed_color[2], 10);
        }
        var r = Math.floor(this.number(limits[0]));
        var g = Math.floor(this.number(limits[1]));
        var b = Math.floor(this.number(limits[2]));
        //var a = parseFloat(Math.random()).toFixed(2);
        return [r,g,b];
    };

};

var AwesomeModel = Backbone.NestedModel.extend({
    push: function (arg, val) {
        if(typeof this.get(arg) == 'undefined'){
            this.set(arg, []);
        }
        var arr = _.clone(this.get(arg));
        arr.push(val);
        this.set(arg, arr);
    },

    unset_array: function (arg, index) {
        var arr = _.clone(this.get(arg));
        arr.splice(index, 1);
        this.set(arg, arr);
    },

    make_seed: function (args) {
        var random = new AwesomeRandom();
        var self = this;
        var rules = args.rules;
        var seed = args.seed;
        var fields = args.fields;
        var seed_card_color = args.seed_card_color;

        if(seed_card_color === null) {
            seed_card_color = random.color(seed_card_color);
        }

        $.each(fields, function (key, value) {
            if(value.type == 'group'){
                var fields = {};
                $.each(value.members, function (index, inner_value) {
                    fields[inner_value] = value.field;

                });
                seed = self.make_seed({
                    fields: fields,
                    seed: seed,
                    seed_card_color: seed_card_color,
                    //seed_text_color: seed_text_color
                });
            }else{
                var field_value  = null;
                switch (value.type){
                    case 'number':
                        field_value = random.number(value.limits);
                        break;
                    case 'boolean':
                        field_value = random.boolean();
                        break;
                    case 'size':
                        field_value = random.size(value.limits);
                        break;
                    case 'percent':
                        field_value = random.percent(value.limits);
                        break;
                    case 'radio':
                        field_value = random.radio(value.values);
                        break;
                    case 'array':
                        field_value = random.array(value.values);
                        break;
                    case 'color':
                        var alpha = null;
                        if(value.group == 'card'){
                            alpha = '0.' + random.number([0,99]);
                            var color = random.color(seed_card_color);
                            field_value = 'rgba(' + color.join(',') + ',' +  alpha + ')';
                        }
                        if(value.group == 'text'){
                            alpha = '0.' + random.number([50,99]);
                            if(seed_card_color === null) {
                                return;
                            }
                            var inverted = random.black_or_white(seed_card_color);
                            field_value = 'rgba(' + inverted.join(',') + ',' +  alpha + ')';
                        }
                        break;
                }
                seed[key] = field_value;
            }
        });
        return seed;
    },


    random: function () {
        var random_values = {};
        var args = {
            fields: fields,
            seed: random_values,
            seed_card_color: null,
            //seed_text_color: null
        };
        var seed = this.make_seed(args);

        var layout = model.get('layout');
        var styles = model.get('styles.' + layout);

        $.each(styles, function (key, value) {
            if($.inArray(key, rules[layout].exclude) > -1){
                return;
            }
            if(seed.hasOwnProperty(key)){
                model.set('styles.' + layout + '.' + key, seed[key]);
            }
        });
    }
});